import branch from "branch-sdk";
import { handleBranchTrafficData } from "./branchTrafficManager";
import { Native } from "../platform/android/nativeBridge";

const BRANCH_KEY = import.meta.env.VITE_BRANCH_KEY;

let initPromise;

/** Initializes Branch once. Safe to call multiple times. */
export const initBranch = () => {
  if (!initPromise) {
    initPromise = new Promise((resolve, reject) => {
      branch.init(BRANCH_KEY, (err, data) => {
        if (err) {
          reject(err);
        } else {
          // Extract the clean JSON deep link data (e.g., ~campaign) for Web Attribution
          const payload = data?.data_parsed;

          if (payload) {
            // Only run this for pure Web browsers.
            if (!Native.isApp) {
              handleBranchTrafficData(payload);
            }
          }
          resolve(data);
        }
      });
    });
  }
  return initPromise;
};

/** Logs a custom event, e.g. trackBranchEvent("LOGIN"). */
export const trackBranchEvent = async (eventName, eventData = {}) => {
  await initBranch();
  return new Promise((resolve, reject) => {
    branch.logEvent(eventName, eventData, undefined, undefined, (err) =>
      err ? reject(err) : resolve(true)
    );
  });
};

/** Links the backend user ID to the Branch session. */
export const setBranchIdentity = async (userId) => {
  await initBranch();
  return new Promise((resolve, reject) => {
    branch.setIdentity(String(userId), (err, data) => (err ? reject(err) : resolve(data)));
  });
};

/** Clears the current user's Branch session on logout. */
export const logoutBranchSession = async () => {
  await initBranch();
  return new Promise((resolve, reject) => {
    branch.logout((err) => (err ? reject(err) : resolve(true)));
  });
};
